import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { AgrPageToolbarModule } from '@next/core-lib/components';
import { AgrSharedModule } from '@next/core-lib/shared';
import { AgrWrapperModule } from '@next/core-lib/wrapper';

@NgModule({
  declarations: [
    // add shared components here
  ],
  imports: [
    FormsModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    AgrSharedModule,
    AgrWrapperModule,
    AgrPageToolbarModule,
  ],
  exports: [
    FormsModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    AgrSharedModule,
    AgrWrapperModule,
    AgrPageToolbarModule,
  ],
  providers: [
    // add shared services and guards here
    // ApiService,
  ],
})
export class SharedModule {}
